export default __webpack_public_path__ + "static/media/Cart_Icon.d925dce9.svg";